import { render, staticRenderFns } from "./SolicitudVehiculoHistoricoEstado.vue?vue&type=template&id=448dbd8e"
import script from "./SolicitudVehiculoHistoricoEstado.vue?vue&type=script&lang=js"
export * from "./SolicitudVehiculoHistoricoEstado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports